"use client"
import { useRouteChange } from "../hooks/useRouteChange";

export const ScrollToTop = () => {
  useRouteChange(() => {
    window.scroll(0, 0);
  })

  return null
}